import { useEffect, useState } from "react";
import { getProductsController } from "../../../../node_modules/shops-query/src/modules/products";
import { imagePrefix, shopid } from "../../../utils/url";
import { Link } from "react-router-dom";

const NewArrivals = () => {
  const [latestProducts, setLatestProducts] = useState([]);

  useEffect(() => {
    const showProducts = async () => {
      try {
        const productsRes = await getProductsController(shopid);
        const sorted = [...productsRes].sort(
          (a, b) => new Date(b.addedon) - new Date(a.addedon)
        );
        const latestFour = sorted.slice(0, 6);
        setLatestProducts(latestFour);
      } catch (error) {
        console.log("Error fetching products:", error);
      }
    };

    showProducts();
  }, []);

  return (
    <div className="mt-[40px] sm:mt-[40px] font-poppins ">
      <div
        className="
      mt-8 sm:mt-[24px]
      sm:w-full mx-auto
      overflow-hidden 
      scrollbar-hide 
      pb-6
      md:p-12 md:-ml-6"
      >
        <div className="flex items-center justify-between max-w-8xl w-full sm:px-6 pb-6">
          <p className="font-medium text-[20px] sm:text-[28px] md:text-[32px] uppercase ml-[16px] sm:ml-[1%]">
            New Arrivals
          </p>
          <Link to="/latest">
            <p className="font-semibold mb-2 sm:mb-0 text-[14px] sm:text-[18px] md:text-[18px] uppercase underline underline-offset-2 cursor-pointer text-primary-default mt-2 sm:mt-0 mr-4 sm:-mr-5">
              View All
            </p>
          </Link>
        </div>

        <div className="relative left-1/2 right-1/2 -mx-[50vw] w-screen border-b border-neutral-halfwhite border-y md:pb-10">
          <div
            className="
            flex gap-6 sm:gap-4 overflow-x-auto
            sm:grid sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6
            md:ml-[4%] sm:mr-8 md:pt-9 px-4 sm:px-8 md:py-0 py-6"
          >
            {latestProducts.map((product) => (
              <div key={product.id} className="w-[150px] sm:w-auto flex-shrink-0">
                <Link to="/all-products">
                  <img
                    src={imagePrefix + product.featureImage}
                    alt={product.name}
                    className="h-[180px] sm:h-[250px] md:h-[300px] lg:h-[350px] object-cover"
                  />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewArrivals;